import { global } from ".";
import {synchronizeConsentInformation} from "../cookiebanner/domain/synchronizeConsentInformation";
import { trackAdvertisingId } from "../thirdpartytracking/trackAdvertisingId";
import { appType, appVersion, runningInApp } from "./detectionFunctions";
import { retrieveNativeAppEvents } from "./nativeAppEvents";

void synchronizeConsentInformation().then(() => {
    void trackAdvertisingId();
});

global.assignNamespace({retrieveNativeAppEvents, runningInApp, appType, appVersion});